<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Customer Delivered Orders</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            add_second_shipping_invoice: 'add_second_shipping_invoice'
          }"
          :addSecondOrderInvoiceButton="true"
          :openSecondOrderInvoiceModal="openSecondOrderInvoiceModal"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :filterTable="filterTable"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="qrCodeValues.find(x => x == r.order_id) ? 'background-color: #FFF9C4' : '' "
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID]"
                    v-model="qrCodeValues"
                  />
                </td>
                <!-- <td>
                  <display-branch :data="r" />
                </td> -->
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-users :orderData="r" />
                </td>
                <td><i
                    class="fa fa-qrcode"
                    aria-hidden="true"
                  ></i>{{ r.order_id }}</td>
                <td>{{ r.theOrderID }}</td>
                <td class="ws-nowrap">
                                    <i v-if="r.fcm_token" class="material-icons customer-device-icon">smartphone</i>
                  <i v-else class="material-icons customer-device-icon">language</i>
                  <img v-if="r.profile_image" :src="`${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                  <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                    {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                  </span>
                  <span v-else>
                    {{ r.full_name }}
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td class="customer-note-color"> {{ r.customer_note }} </td>
                <td>
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                      (r.product_url.length > 10 ? '...' : '')
                  }}</a>
                </td>
                <td>{{
                  r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : '')
                }}</td>
                <td>{{ r.quantity }}</td>
                <td>{{ r.country }}</td>
                <td>{{ r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : '' }}</td>
                <td>{{ r.purchase_note }}</td>
                <td>{{ r.note }}</td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-dates :orderData="r" />
                </td>
                <td>{{ r.bank_name }}</td>
                <td
                  v-if="$_has_perm('view_order_detail')"
                  style="padding-left:10px; padding-right:5px"
                >
                  <a
                    style="color:#01579B"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('return_delivered_order_to_purchased_order')"
                  style="padding-left:0px; padding-right:10px"
                >
                  <a
                    style="color:#eb8545"
                    tooltip="Return to purchase"
                    @click="returnToPurchase(r.order_id)"
                  >
                    <i class="material-icons">settings_backup_restore</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            :isOrder="true"
            v-if="isMobile"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  <i
                    class="fa fa-qrcode"
                    aria-hidden="true"
                  ></i> {{ r.order_id }} , <br />
                  {{ r.theOrderID }} , <br />
                  {{
                    r.product_name.substr(0, 35) +
                      (r.product_name.length > 35 ? '...' : '')
                  }} , <br />
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                      (r.product_url.length > 10 ? '...' : '')
                  }}</a>
                  <br />
                  <span v-if="r.country == 'USA'">
                    <flag iso="um" />
                  </span>
                  <span v-else-if="r.country == 'Turkey'">
                    <flag iso="tr" />
                  </span>
                  <span v-else-if="r.country == 'China'">
                    <flag iso="cn" />
                  </span>
                  <span v-else-if="r.country == 'German'">
                    <flag iso="de" />
                  </span>
                  <span v-else-if="r.country == 'UK'">
                    <flag iso="gb" />
                  </span>
                  &nbsp; {{ r.country }} ,
                  <br />
                  PurchaseNote: {{ r.purchase_note }}
                  <br />
                  Quantity: {{ r.quantity }}
                </td>
                <td>
                  Customer name: {{ r.full_name }} , <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else>{{ r.created_at }}</span> <br />
                  Confirm date: {{ r.confirm_date }} , <br />
                  <a
                    v-if="$_has_perm('view_order_detail')"
                    style="color:#01579B; display: inline-block; padding-right: 3px"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                  <span
                    v-if="$_has_perm('return_delivered_order_to_purchased_order')"
                    style="padding-left:0px; padding-right:5px; float: left;"
                  >
                    <a
                      style="color:#eb8545"
                      tooltip="Return to purchase"
                      @click="returnToPurchase(r.order_id)"
                    >
                      <i class="material-icons">settings_backup_restore</i>
                    </a>
                  </span>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <add-order-invoice
            :formData="generateInvoiceData"
            :orderInvoiceModal="orderInvoiceModal"
            @close="orderInvoiceModal = false"
            @invoice-created="getResults()"
            :is_second_invoice="true"
          />

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import mobileDatatable from './mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'
import AddOrderInvoice from '../components/orderInvoice/AddOrderInvoice.vue'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails,
    'mobile-datatable': mobileDatatable,
    AddOrderInvoice
  },
  mounted() {
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: 'Check box', value: '1' },
      {
        label: 'User',
        text: 'User',
        value: '2',
        sortable: false,
        searchable: false,
        name: 'user'
      },
      {
        label: 'Qr ID',
        text: 'Qr ID',
        value: '3',
        sortable: true,
        searchable: true,
        name: 'order_id'
      },
      {
        label: 'OrderID',
        text: 'OrderID',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'theOrderID'
      },
      {
        label: 'Customer Name',
        text: 'Customer Name',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'full_name'
      },
      {
        label: 'Customer Note',
        text: 'Customer Note',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'customer_note'
      },
      {
        label: 'Product URL',
        text: 'Product URL',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'product_url'
      },
      {
        label: 'Product Name',
        text: 'Product Name',
        value: '8',
        sortable: true,
        searchable: true,
        name: 'product_name'
      },
      {
        label: 'Qty',
        text: 'Qty',
        value: '9',
        sortable: true,
        searchable: true,
        name: 'quantity'
      },
      {
        label: 'Warehouse',
        text: 'Warehouse',
        value: '10',
        sortable: true,
        searchable: true,
        name: 'country'
      },
      {
        label: 'Type',
        text: 'Type',
        value: '11',
        sortable: true,
        searchable: true,
        name: 'transportation_type_obj',
      },
      {
        label: 'Purchase Note',
        text: 'Purchase Note',
        value: '12',
        sortable: true,
        searchable: true,
        name: 'purchase_note'
      },
      {
        label: 'Order Note',
        text: 'Order Note',
        value: '13',
        sortable: true,
        searchable: true,
        name: 'note'
      },
      {
        label: 'Date',
        text: 'Date',
        value: '14',
        sortable: true,
        searchable: true,
        name: 'deliver_date'
      },
      {
        label: 'Bank',
        text: 'Bank',
        value: '15',
        sortable: true,
        searchable: true,
        name: 'bank_name',
      },
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      qrCodeValues: [],
      generateInvoiceData: {},
      orderInvoiceModal: false,
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/user_delivery_order',
      orderDetailUrl: 'api/show_order_detail',
      returnToPurchaseUrl: 'api/orders/',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      queryParameter: true,
      filterMade: false,
      totalResult: 0,
      detialData: {
        the_tl_price: '',
        order_id: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        coupon_percentage: '',
        item_type: '',
        size: '',
        type: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_weight: '',
        item_price: '',
        tax: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        theOrderID: '',
        refund_reason: '',
        bank_name: '',
        country: '',
        order_date: '',
        track_number: '',
        discount: '',
        note: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },
  methods: {
    checkAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    unCheckAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(errors => { })
    },

    openSecondOrderInvoiceModal() {
      if (this.qrCodeValues.length < 1) {
        swal({
          text: 'Please at least select one order or customer!',
          icon: 'warning',
          dangerMode: true,
        })

        return
      }

      let customerIds = []
      let ordersArr = []
      this.qrCodeValues.forEach((x, i) => {
        let obj = {
          order_id: null,
          customer_name: null,
          phone: null,
          customer_id: null,
          the_order_id: null,
        }
        x.forEach((y, j) => {
          if (j === 0) {
            obj.order_id = y
          } else if (j === 1) {
            obj.customer_name = y
          } else if (j === 2) {
            obj.phone = y
          } else if (j === 3) {
            customerIds.push(y)
            obj.customer_id = y
          } else if (j === 4) {
            obj.the_order_id = y
          }
        })
        ordersArr.push(obj)
      })

      if (this.checkDiff(customerIds)) {
        swal({
          text: 'You selected different customers',
          icon: 'warning',
          dangerMode: true,
        })

        return
      }

      this.generateInvoiceData = {
        volume: 0,
        delivery_price: 0,
        customer_id: ordersArr[0].customer_id,
        customer_name: ordersArr[0].customer_name,
        phone: ordersArr[0].phone,
        orders: ordersArr,
      }
      console.log(this.generateInvoiceData)
      this.orderInvoiceModal = true
    },

    generateInvoiceCustomer(id) {
      const customer = this.customersList.find((x) => x.value === id)

      this.generateInvoiceData = {
        customer_id: customer.value,
        customer_name: customer.text,
        phone: customer.phone,
        orders: [],
      }

      this.orderInvoiceModal = true
    },

    checkDiff(arr) {
      return arr.length !== 0 && new Set(arr).size !== 1
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    returnToPurchase(id) {
      swal({
        title: 'Are you sure?',
        text: 'You really want to return this order to Purchased section?',
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .put(this.returnToPurchaseUrl + id + '/return_to_purchase', '', {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(response => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal('Error', `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.detailResults = data.data
          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td
{
  padding: 0 5px !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.icon-enlarge,
.icon-pencil {
  color: navy;
}

.icon-bin2 {
  color: red;
}

.icon-calendar {
  color: green;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userDeliveredOrder.vue